export default "__VITE_ASSET__Bbxh3NXc__"